import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ModalLayoutProps {
  title: string;
  children: React.ReactNode;
  footer: React.ReactNode;
}

export function ModalLayout({ title, children, footer }: ModalLayoutProps) {
  return (
    <div className="flex flex-col h-full max-h-[calc(100vh-4rem)] bg-white">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex-shrink-0 px-6 py-4 border-b border-gray-200 bg-white"
      >
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
      </motion.div>
      
      {children}
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex-shrink-0 px-6 py-4 bg-white border-t border-gray-200"
      >
        {footer}
      </motion.div>
    </div>
  );
}